import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { READING_TEST_TYPE } from '../../lib/const';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReadingTestResult } from './ducks/readingTestResult';

const ReadingTestResult = ()=>{
    const { id } = useParams();
    const readingTestResult = useSelector(state => state.readingTestResult);
    const auth = useSelector(state => state.auth);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch( fetchReadingTestResult(id) );
    }, [dispatch, id]);
    
    if(!auth.authenticated) return <div className="no_data"><p>로그인 후 이용해주세요.</p></div>;
    if(readingTestResult.loading===null)return null;
    if(readingTestResult.loading) return null;
    if(null!==readingTestResult.message) return <div className="no_data"><p>{readingTestResult.message}</p></div>;
    
    return (
        <div className="subpage">
            <div id="contents" className="list_page reading_test test_end">
                <div className="inner">
                    <div className="section">
                        <div className="title_area">
                            <div><img src={`${process.env.PUBLIC_URL}/images/common/reading_test_img.png`} alt="독서력진단 이미지" /></div>
                            <h2>독서력 진단</h2>
                            <p className="desc">{READING_TEST_TYPE[readingTestResult.testResult.type]}진단을 완료 하셨습니다.</p>
                        </div>

                        <div className={`report_wrap type${readingTestResult.testResult.type}`}>
                                <div className="title_area"><p className="title"><strong>{READING_TEST_TYPE[readingTestResult.testResult.type]}진단 분석</strong></p></div>
                                <div className="cont_area">
                                    { readingTestResult.testResult.test1Report!=null &&
                                        <div className="cont_inner">
                                            <div className="title_wrap"><div className="icon icon01"></div><span>기본진단 분석</span><strong className="arrow">{readingTestResult.testResult.test1Report.name}</strong></div>
                                            <div className="bullet_list" dangerouslySetInnerHTML={{__html:readingTestResult.testResult.test1Report.description}}></div>
                                        </div>
                                    }
                                    { readingTestResult.testResult.test2Report!=null &&
                                        <div className="cont_inner">
                                            <div className="title_wrap"><div className="icon icon02"></div><span>심화진단 분석</span><strong className="arrow">{readingTestResult.testResult.test2Report.name}</strong></div>
                                            <div className="bullet_list" dangerouslySetInnerHTML={{__html:readingTestResult.testResult.test2Report.description}}></div>
                                        </div>
                                    }
                                    { readingTestResult.testResult.test3Report!=null &&
                                        <div className="cont_inner">
                                            <div className="title_wrap"><div className="icon icon03"></div><span>종합진단 분석</span><strong className="arrow">{readingTestResult.testResult.test3Report.name}</strong></div>
                                            <div className="bullet_list" dangerouslySetInnerHTML={{__html:readingTestResult.testResult.test3Report.description}}></div>
                                        </div>
                                    }
                                </div>
                            </div>
                        <Link className="btn _lg _gray" to={`/${window.schoolCode}/reading/test`}><strong className="arrow">독서력진단 홈으로 이동</strong></Link>
                    </div>
                </div>
            </div>
        </div>
    );
}// ReadingTestResult
export default ReadingTestResult;
